import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";
import { DadosContrato } from "../../../interfaces/entities/MeuCadastro/DadosContrato";
import "./styles.css";

const ContractData: React.FC<{ dadosContrato: DadosContrato }> = ({ dadosContrato }) => {

  const { textStyleAccessibility, calculateTextStyle, contrastStyle, contrastBorderAccessibility } = useAccessibility();
  const font14Style = calculateTextStyle(14)

  return (
    <div className="registration-data-card-holder" >
      <div className="registration-data-card" style={{...contrastBorderAccessibility, ...contrastStyle}}>
        <div className="registration-data-row">
          <span style={textStyleAccessibility} className="registration-data-title">Dados do contrato</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary" style={{...contrastBorderAccessibility, ...contrastStyle}}>
          <span style={font14Style} className="registration-data-key">Código</span>
          <span style={font14Style} className="registration-data-value">{dadosContrato.codigo}</span>
        </div>
        <div className="registration-data-row" style={{...contrastBorderAccessibility, ...contrastStyle}}>
          <span style={font14Style} className="registration-data-key">Contrato</span>
          <span style={font14Style} className="registration-data-value">{dadosContrato.contrato}</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary" style={{...contrastBorderAccessibility, ...contrastStyle}}>
          <span style={font14Style} className="registration-data-key">Tipo</span>
          <span style={font14Style} className="registration-data-value">{dadosContrato.tipoUsr === 'DEPEND' ? 'Dependente' : 'Titular'}</span>
        </div>
        <div className="registration-data-row" style={{...contrastBorderAccessibility, ...contrastStyle}}>
          <span style={font14Style} className="registration-data-key">Data inclusão</span>
          <span style={font14Style} className="registration-data-value">{dadosContrato.dataInclusao}</span>
        </div>
        <div className="registration-data-row registration-data-row-secondary radius-bottom" style={{...contrastBorderAccessibility, ...contrastStyle}}>
          <span style={font14Style} className="registration-data-key">Data exclusão</span>
          <span style={font14Style} className="registration-data-value">
            {!!dadosContrato.dataExclusao ? dadosContrato.dataExclusao : '-'}
          </span>
        </div>
      </div>
    </div>
  )
}

export default ContractData;